// App.js에 있던 내용을 그대로 옮기세요.
// /home/oh33090489/real-estate-app/frontend/src/constants/bldLabels.js
export const BLD_TYPE_LABELS = {
  "apt": "아파트",
  "business-bld": "업무용빌딩",
  "shop-house": "상가주택",
  "land": "토지",
  "sale-shop": "분양상가",
  "s-home-bld": "단독주택",
  "multi-household": "다가구주택",
  "single-room-bld": "원룸건물",
  "single-room": "원룸",
  "shop": "상가",
  "multi-purpose": "다용도",
  "office": "사무실",
  "e-apt": "오피스텔",
  "etc": "기타",
  "metro-house": "도시형주택",
  "row-house": "연립주택",
  "single-room-owner": "원룸주인세대",
  "multi-house": "다세대",
  "villa": "빌라",
};